import { BugOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Descriptions,
  Empty,
  Form,
  Modal,
  Pagination,
  Select,
  Statistic,
  Typography,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Option } from 'antd/lib/mentions';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  createNewGrievance,
  getGrievanceIssuesTypes,
  getGrievanceOfUser,
} from '../../../Services/GrievanceServices/GrievanceService';
import { getUser } from '../../../Services/UserProfileServices';
import TimeFromNow from '../../Common/Components/TimeFromNow';
import './index.css';

const Grievance: React.FC = () => {
  const [grievance, setGrievance] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [visible, setVisibility] = useState(false);
  const [grievanceIssues, setGrievanceIssues] = useState<any>({});
  const [form] = Form.useForm();
  const [user, setUser] = useState({
    firstName: '',
  });
  const { t } = useTranslation();

  const getGrievanceOfUserLocal = useCallback(() => {
    getGrievanceOfUser(page - 1, pageSize)
      .then((res) => res.data)
      .then((res) => {
        setTotalCount(res.totalElements);
        setGrievance(res.content);
      });
  }, [page, pageSize]);

  useEffect(() => {
    getGrievanceOfUserLocal();
  }, [getGrievanceOfUserLocal]);
  useEffect(() => {
    getUser()
      .then((res) => res.data)
      .then((res) => {
        setUser({ firstName: res.firstName });
      });
  }, []);
  const showTotal = (total: number, range: number[]) => (
    <Statistic
      title={`${range[0]}-${range[1]} of ${total} items`}
      valueStyle={{ visibility: 'hidden' }}
    />
  );

  const onPageAndPageSizeChange = (pageRef: number, pageSizeRef: number) => {
    setPage(pageRef);
    setPageSize(pageSizeRef);
  };

  const showModal = () => {
    setVisibility(true);
  };

  const handleOk = (e: any) => {
    form.submit();
  };

  const handleCancel = (e: any) => {
    setVisibility(false);
  };

  const onDetailsEntered = (values: any) => {
    createNewGrievance(values).then(() => {
      setVisibility(false);
      getGrievanceOfUserLocal();
      form.resetFields();
    });
  };

  return (
    <div className='grievanceRoot'>
      <Typography.Title
        level={2}
        style={{
          marginLeft: 'auto',
          color: 'var(--ant-primary-color)',
          width: '95%',
          marginRight: 'auto',
          marginTop: 15,
        }}
      >
        {t('Report Issue')}
      </Typography.Title>
      <div className='pagination header'>
        <Pagination
          size='small'
          total={totalCount}
          defaultCurrent={6}
          current={page}
          defaultPageSize={20}
          showSizeChanger={true}
          showTotal={showTotal}
          responsive={true}
          onChange={onPageAndPageSizeChange}
        />

        <Button
          className='reportButton'
          type='primary'
          onClick={showModal}
          icon={<BugOutlined />}
        >
          {t('Report an Issue')}
        </Button>
        <Button
          className='reportButton'
          type='primary'
          target='_blank'
          href='https://qa.pbfintechaa.com/account-aggregator/grievence-redressal'
        >
          {t('Grievance officer details')}
        </Button>

        <Modal
          title={t('Report an Issue')}
          open={visible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Form
            form={form}
            name='basic'
            onFinish={onDetailsEntered}
            autoComplete='off'
            scrollToFirstError={true}
          >
            <Form.Item
              name={'issueType'}
              rules={[
                {
                  required: true,
                  message: '* Required field',
                },
              ]}
            >
              <Select
                placeholder='Select type of Issue'
                style={{ width: '50%' }}
                loading={Object.keys(grievanceIssues).length === 0}
                // tslint:disable-next-line: jsx-no-lambda
                onDropdownVisibleChange={(open) => {
                  if (open && Object.keys(grievanceIssues).length === 0) {
                    getGrievanceIssuesTypes()
                      .then((res) => res.data)
                      .then((res) => {
                        setGrievanceIssues(res);
                        // tslint:disable-next-line: no-console
                      });
                  }
                }}
              >
                {Object.keys(grievanceIssues)
                  .sort()
                  .map((key, index) => (
                    <Option key={index.toString()} value={key}>
                      {grievanceIssues[key]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={'description'}
              rules={[
                {
                  required: true,
                  message: '* Required field',
                },
              ]}
            >
              <TextArea
                style={{ marginTop: 10 }}
                rows={3}
                placeholder='Enter description'
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
      <Card className='grievanceHome'>
        {grievance && grievance.length ? (
          grievance.map((g: any, index: number) => (
            <Descriptions
              column={2}
              className='descriptionRoot'
              key={index}
              title={
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <Typography.Text
                      style={{ color: 'var(--ant-primary-color)' }}
                    >
                      {g.issueType}
                    </Typography.Text>
                    <Typography.Text style={{ marginLeft: 10 }}>
                      ({g.status})
                    </Typography.Text>
                  </div>
                  <Typography.Text>
                    <TimeFromNow date={g.updatedOn} title={t('Updated')} />
                  </Typography.Text>
                </div>
              }
            >
              <Descriptions.Item label='Description'>
                {g.description}
              </Descriptions.Item>

              <Descriptions.Item label='Feedback'>
                {g.feedback ? g.feedback : 'No feedback found.'}
              </Descriptions.Item>
            </Descriptions>
          ))
        ) : (
          <Empty
            style={{ margin: '10px auto' }}
            description={
              <Typography.Text className='noAccountFound'>
                {t('No')} {t('Issues Found')}
              </Typography.Text>
            }
          />
        )}
      </Card>
    </div>
  );
};

export default Grievance;
